import { render } from "./SignInAccount.vue?vue&type=template&id=3279f39a&scoped=true&ts=true&lang=pug"
import script from "./SignInAccount.vue?vue&type=script&lang=ts"
export * from "./SignInAccount.vue?vue&type=script&lang=ts"

import "./SignInAccount.vue?vue&type=style&index=0&id=3279f39a&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3279f39a"]])

export default __exports__